import { render, staticRenderFns } from "./GeneralLayout.vue?vue&type=template&id=29da3e0a&scoped=true&"
import script from "./GeneralLayout.vue?vue&type=script&lang=js&"
export * from "./GeneralLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29da3e0a",
  null
  
)

export default component.exports